module.exports = __webpack_public_path__ + "img/Eye.d163cd09.svg";